import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { AdNetworksRequestParams, AdNetworksTableDto } from "../../../company/types/ad-networks";
import { accountOverviewQueryKeys } from "../queryKeyFactory";

type QueryOptions = {
    isEnabled?: boolean;
};

export default function useAdNetworksTableQuery(
    params: AdNetworksRequestParams,
    options: QueryOptions = {},
): UseQueryResult<AdNetworksTableDto> {
    const { isEnabled = true } = options;

    return useQuery({
        queryKey: accountOverviewQueryKeys.adNetworksTable(params),
        enabled: isEnabled && salesSettingsHelper.isSiAdNetworksFeatureEnabled,
        queryFn({ signal }) {
            return salesApiService.accountOverview.fetchAdNetworksTable(params, {
                cancellation: signal,
            });
        },
    });
}
